import {bootstrapApplication} from '@angular/platform-browser';
import {environmentCurrent} from 'env-config';
import {appConfig} from './app/app.config';
import {App} from './app/app';

// Detect stale chunk errors after deployment and force a reload to fetch the new index.html.
// Ignore blocked third-party scripts (e.g. analytics blocked by ad blockers).
window.addEventListener('error', (event) => {
  const target = event.target as HTMLElement | null;
  if (target?.tagName === 'SCRIPT' || target?.tagName === 'LINK') {
    const src = (target as HTMLScriptElement).src
      || (target as HTMLLinkElement).href
      || '';
    // Only reload for first-party asset failures (our own chunks), not third-party scripts
    const isThirdParty = src && !src.startsWith(window.location.origin);
    if (isThirdParty) return;

    const alreadyReloaded = sessionStorage.getItem('chunk-reload');
    if (!alreadyReloaded) {
      sessionStorage.setItem('chunk-reload', 'true');
      window.location.reload();
    }
  }
}, true);

// Clear the reload flag on successful bootstrap
bootstrapApplication(App, appConfig)
  .then(() =>  { sessionStorage.removeItem('chunk-reload'); console.log(`Application bootstrapped successfully! Version: ${environmentCurrent.app.version}`); } )
  .catch((err) => {
    // Handle chunk import errors (dynamic imports)
    if (err?.message?.includes('Failed to fetch dynamically imported module') ||
        err?.message?.includes('Loading chunk') ||
        err?.message?.includes('MIME type')) {
      const alreadyReloaded = sessionStorage.getItem('chunk-reload');
      if (!alreadyReloaded) {
        sessionStorage.setItem('chunk-reload', 'true');
        window.location.reload();
      }
    }
    console.error(err);
  });
